import { useQueryParameter } from '@hooks'

/**
 * Retrieves a referral code from the URL if present
 */
export const useReferralCode = (): Maybe<string> => {
  return useQueryParameter('referral_code')
}
